module.exports = new __parcel__URL__("step_five_vector.ea9a3b76.png").toString();